import { orderEvent } from '@/constants';
import { ServiceData } from '..';
export class ServiceDataOrderEvent extends ServiceData {
    reqBody;
    orderEvent = null;
    orderId = '';
    workerCode = '';
    cancelReason = '';
    constructor(data) {
        super();
        Object.assign(this, data);
    }
    setOrderEvent(value) {
        this.orderEvent = value;
    }
    createReqBody() {
        // 배차 (즉시배차)
        if (this.orderEvent === orderEvent.ALLOCATE) {
            return this.allocate();
        }
        // 재배차
        if (this.orderEvent === orderEvent.REALLOCATE) {
            return this.reallocate();
        }
        // 배차취소
        if (this.orderEvent === orderEvent.ALLOCATE_CANCEL) {
            return this.allocateCancel();
        }
        // 주문취소 (배달취소)
        if (this.orderEvent === orderEvent.CANCEL) {
            return this.cancel();
        }
        // 배차요청 orderEvent.WORKER_REQUEST
        return this.workerRequest();
    }
    /**
     * 배차요청
     * @returns
     */
    workerRequest() {
        return {
            workerCode: this.workerCode,
            orderEvent: orderEvent.WORKER_REQUEST,
        };
    }
    /**
     * 즉시배차
     * @returns
     */
    allocate() {
        return {
            workerCode: this.workerCode,
            orderEvent: orderEvent.ALLOCATE,
        };
    }
    /**
     * 재배차
     * @returns
     */
    reallocate() {
        return {
            workerCode: this.workerCode,
            orderEvent: orderEvent.REALLOCATE,
        };
    }
    /**
     * 배차취소
     * @returns
     */
    allocateCancel() {
        const data = {
            orderEvent: orderEvent.ALLOCATE_CANCEL,
        };
        if (this.cancelReason) {
            data.cancelReason = this.cancelReason;
        }
        return data;
    }
    /**
     * 배달취소
     * @returns
     */
    cancel() {
        const data = {
            orderEvent: orderEvent.CANCEL,
        };
        if (this.cancelReason) {
            data.cancelReason = this.cancelReason;
        }
        return data;
    }
}
